__turbopack_context__.v({
  "bar": "QueueModal-module__GfrR2W__bar",
  "barFill": "QueueModal-module__GfrR2W__barFill",
  "barVertical": "QueueModal-module__GfrR2W__barVertical",
  "barWrapper": "QueueModal-module__GfrR2W__barWrapper",
  "buttons": "QueueModal-module__GfrR2W__buttons",
  "main": "QueueModal-module__GfrR2W__main",
  "position": "QueueModal-module__GfrR2W__position",
  "positionWrapper": "QueueModal-module__GfrR2W__positionWrapper",
});
